exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".jumbotron {\n\tpadding: 1em 2em 4em 2em !important;\n}\n\n/* \n.half{\n  border-top-right-radius: 0px !important;\n  border-top-left-radius: 0px !important;\n  border-bottom-left-radius: 7px !important;\n  border-bottom-right-radius: 7px !important;\n  background-color: #414D61 !important;\n  border: #3F5067 !important;\n} */", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/ingvars/BNC-Lab/front/src/app/summary/summary.component.css
// module id = ../../../../../src/app/summary/summary.component.css
// module chunks = 0